import EmailEditor from 'Common/services/emailEditor';

export default class EmailEditorCtrl {
  constructor($timeout) {
    'ngInject';

    this.$timeout = $timeout;
  }

  $onInit() {
    if (typeof this.isRecipient === 'undefined') {
      this.isRecipient = true;
    }
    if (typeof this.isCc === 'undefined') {
      this.isCc = true;
    }
    if (typeof this.isSubject === 'undefined') {
      this.isSubject = true;
    }
    if (typeof this.isSend === 'undefined') {
      this.isSend = true;
    }
    if (typeof this.btnSendText === 'undefined') {
      this.btnSendText = 'Send';
    }

    this.emailEditor = new EmailEditor(this.emailObj);
  }

  selectRecipient(recipient) {
    this.emailEditor.onSelectRecipient(recipient);

    this.updateRecipients();
  }

  removeRecipient(recipient) {
    this.emailEditor.onRemoveRecipient(recipient);

    this.updateRecipients();
  }

  selectCc(cc) {
    this.emailEditor.onSelectCc(cc);

    this.updateRecipients();
  }

  removeCc(cc) {
    this.emailEditor.onRemoveCc(cc);

    this.updateRecipients();
  }

  updateSubject(subject) {
    this.emailEditor.onUpdateSubject(subject);

    this.updateRecipients();
  }

  updateBody(body) {
    this.emailEditor.onUpdateBody(body);

    this.updateRecipients();
  }

  updateRecipients() {
    this.onEmailChange({ emailModel: this.emailEditor.emailObj });
  }
}
